module.exports = __webpack_public_path__ + "static/media/imprint-en.d32d9997.md";